import { useEffect, useState, useMemo } from "react"
import ApiService from "../../services/apiService";
import Loader from "../../elements/Loader";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function PromotionSegment() {
    const [segment, setSegment]           = useState([]);
    const [loading, setLoading]           = useState(false);
    const [collapsedGroups, setCollapsed] = useState({});

    useEffect(() => { getSegments(); }, []);

    const getSegments = async () => {
        setLoading(true);
        ApiService.get('promotion/segment').then((response) => {
            setLoading(false);
            setSegment(response.data)
        }).catch(() => setLoading(false));
    }

    const assignUser = () => {
        setLoading(true);
        ApiService.post('promotion/segment/assign-user').then((res) => {
            setLoading(false);
            if (res?.assigned !== undefined) {
                toast.success(`Assigned ${res.assigned} users across segments`);
            } else {
                toast.success('Users assigned successfully');
            }
            getSegments();
        }).catch((err) => {
            setLoading(false);
            const msg = err?.response?.data?.error?.message || 'Failed to assign users';
            toast.error(msg);
            console.error('assignUser error:', err);
        });
    }

    // Group segments by groupName; ungrouped go under key ''
    const groupedSegments = useMemo(() => {
        const map = {};
        (segment || []).forEach(dp => {
            const key = dp.groupName || '';
            (map[key] = map[key] || []).push(dp);
        });
        // Sort: named groups first (alpha), then ungrouped
        const sorted = Object.entries(map).sort(([a], [b]) => {
            if (!a) return 1; if (!b) return -1;
            return a.localeCompare(b);
        });
        return sorted;
    }, [segment]);

    const toggleGroup = (key) => setCollapsed(prev => ({ ...prev, [key]: !prev[key] }));

    return (
        <div className="row">
            {/* ── Segments Table ── */}
            <div className="col-xl-12">
                {loading && <Loader />}
                <div className="card dz-card" id="bootstrap-table2">
                    <div className="card-header flex-wrap d-flex justify-content-between border-0">
                        <div>
                            <h4 className="card-title">User Segment List</h4>
                        </div>
                        <ul className="nav nav-tabs dzm-tabs">
                            <li className="nav-item" role="presentation">
                                <Link to="/add-segment" className="btn btn-primary">Add Segment</Link>
                            </li>
                            <li className="ml-2 nav-item" role="presentation">
                                <button className="btn btn-primary" onClick={assignUser}>Assign Users</button>
                            </li>
                        </ul>
                    </div>
                    <div className="card-body p-0">
                        {groupedSegments.length === 0 && !loading && (
                            <p className="text-muted text-center py-5">No segments yet. <Link to="/add-segment">Add one</Link></p>
                        )}

                        {groupedSegments.map(([groupKey, items]) => {
                            const isCollapsed = collapsedGroups[groupKey];
                            const label = groupKey || 'Ungrouped';
                            return (
                                <div key={groupKey} className="mb-0">
                                    {/* Group header row */}
                                    <div
                                        onClick={() => toggleGroup(groupKey)}
                                        style={{
                                            background: groupKey ? '#f0eeff' : '#f8f9fa',
                                            borderTop: '1px solid #e5e5e5',
                                            borderBottom: '1px solid #e5e5e5',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            display: 'flex', alignItems: 'center', gap: 8,
                                            userSelect: 'none',
                                        }}
                                    >
                                        <i className={`fa fa-folder${groupKey ? '-open' : ''} me-1`}
                                            style={{ color: groupKey ? '#6c5ffc' : '#aaa', fontSize: 14 }} />
                                        <span style={{ fontWeight: 600, fontSize: 13, color: groupKey ? '#6c5ffc' : '#888' }}>
                                            {label}
                                        </span>
                                        <span className="badge badge-secondary light ms-1" style={{ fontSize: 11 }}>
                                            {items.length}
                                        </span>
                                        <i className={`fa fa-chevron-${isCollapsed ? 'right' : 'down'} ms-auto`}
                                            style={{ fontSize: 11, color: '#aaa' }} />
                                    </div>

                                    {/* Segment rows */}
                                    {!isCollapsed && (
                                        <div className="table-responsive">
                                            <table className="table table-responsive-md mb-0">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th style={{ paddingLeft: 28 }}><strong>#</strong></th>
                                                        <th><strong>Name</strong></th>
                                                        <th><strong>Description</strong></th>
                                                        <th><strong>Filters</strong></th>
                                                        <th><strong>Users</strong></th>
                                                        <th><strong>Action</strong></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {items.map((dp, key) => (
                                                        <tr key={dp.id}>
                                                            <td style={{ paddingLeft: 28 }}><strong>{key + 1}</strong></td>
                                                            <td><span className="w-space-no">{dp.name}</span></td>
                                                            <td style={{ fontSize: 12, color: '#666' }}>{dp.description || '—'}</td>
                                                            <td style={{ fontSize: 11 }}>
                                                                {dp.criteria && Object.entries(dp.criteria).map(([k, v]) => (
                                                                    <span key={k} className="badge badge-light me-1 mb-1"
                                                                        style={{ border: '1px solid #ddd', fontWeight: 400 }}>
                                                                        {k}{v !== true ? `: ${v}` : ''}
                                                                    </span>
                                                                ))}
                                                            </td>
                                                            <td>
                                                                <span className="badge badge-primary light">{dp.userCount ?? '—'}</span>
                                                            </td>
                                                            <td>
                                                                <Link
                                                                    to={`/edit-segment/${dp?.id}`}
                                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                                    title="Edit"
                                                                >
                                                                    <i className="fa fa-pencil" />
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
